import React from "react";

import { IgButton, IgPaper } from "@intelligems/ig-theme";
import { Grid, Typography } from "@mui/material";

import { useSyncAppDiscountFunctions } from "../../../../api/app-discount-functions/sync-app-discount-functions";
import { useConfiguration } from "../../../../api/configurations/use-configuration";
import { useResetDemoStores } from "../../../../api/meta/reset-demo-stores";
import { useManualDeploy } from "../../../../api/plugin-configs/manual-deploy";
import { useSyncScopes } from "../../../../api/subscriptions/sync-scopes";
import { useIsAdmin } from "../../../../api/user-auths/is-admin";
import openNewTab from "../../../../utils/openNewTab";

interface AdvancedActionsProps {
  previewLink: string;
}

export const AdvancedActions = ({ previewLink }: AdvancedActionsProps) => {
  const manualDeploy = useManualDeploy();
  const syncScopes = useSyncScopes();
  const resetDemoStores = useResetDemoStores();
  const syncFunctionCampaigns = useSyncAppDiscountFunctions();

  const shopifyFunctionsEnabled = useConfiguration<boolean>(
    "shopify_functions_enabled"
  );
  const isAdmin = useIsAdmin();

  const onSyncFunctionCampaignsClick = () => {
    syncFunctionCampaigns.mutate();
  };

  return (
    <IgPaper>
      <Grid container direction={"column"} rowSpacing={2}>
        <Grid container item>
          <Grid item xs>
            <Typography variant="h6">Advanced Actions</Typography>
          </Grid>
        </Grid>
        <Grid container textAlign={"center"}>
          <Grid item xs>
            <div>
              <Typography style={{ marginRight: 15 }}>
                Integration Preview
              </Typography>
              <IgButton
                variant="outlined"
                onClick={() => {
                  openNewTab(previewLink, undefined, true);
                }}
              >
                Preview
              </IgButton>
            </div>
          </Grid>
          <Grid item xs>
            <div>
              <Typography style={{ marginRight: 15 }}>
                Deploy New Config File
              </Typography>
              <IgButton
                loading={manualDeploy.isPending}
                variant="outlined"
                onClick={() => {
                  manualDeploy.mutate();
                }}
              >
                Deploy Config
              </IgButton>
            </div>
          </Grid>
          <Grid item xs>
            <div>
              <Typography style={{ marginRight: 15 }}>
                Sync Web-UI Scopes
              </Typography>
              <IgButton
                loading={syncScopes.isPending}
                variant="outlined"
                onClick={() => {
                  syncScopes.mutate();
                }}
              >
                Sync Scopes
              </IgButton>
            </div>
          </Grid>
          <Grid item xs>
            <div>
              <Typography style={{ marginRight: 15 }}>
                Reset Demo Stores
              </Typography>
              <IgButton
                loading={resetDemoStores.isPending}
                variant="outlined"
                onClick={() => {
                  resetDemoStores.mutate();
                }}
              >
                Reset Demo Stores
              </IgButton>
            </div>
          </Grid>
          {shopifyFunctionsEnabled?.value && isAdmin && (
            <Grid item xs>
              <div>
                <Typography style={{ marginRight: 15 }}>
                  Shopify Functions:
                </Typography>
                <IgButton
                  variant={"outlined"}
                  size={"large"}
                  onClick={onSyncFunctionCampaignsClick}
                  loading={syncFunctionCampaigns.isPending}
                >
                  Sync Function
                </IgButton>
              </div>
            </Grid>
          )}
        </Grid>
      </Grid>
    </IgPaper>
  );
};
